import React from 'react'
import { getBadgeTheme, getProductColourTag } from '@helpers/products'
import { BREAKPOINT_SIZES } from '@consts/index'
import Badge from '@components/ui/Badge'
import styles from './styles.module.scss'
import { useMediaQuery } from '@helpers/hooks'

type CollectionTagsProps = {
  tags: string[]
}

function CollectionTags({ tags }: CollectionTagsProps) {
  const tagInfo = getProductColourTag(tags)
  const isTabletOrUp = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.TABLET,
    initialState: true
  })

  if (!tagInfo) return null

  return (
    <Badge
      classes={styles.CollectionTags}
      title={tagInfo.formatted}
      themeColour={getBadgeTheme(tagInfo)}
      medium={isTabletOrUp}
      smallX2={!isTabletOrUp}
    />
  )
}

export default CollectionTags
